module.exports = __webpack_public_path__ + "static/media/letsGo.b941dab6.gif";